import { initializeApp, getApps } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  databaseURL: "https://hangoo-ddb7e-default-rtdb.asia-southeast1.firebasedatabase.app/",
};

let app = null;
if (Object.values(firebaseConfig).every((v) => !!v)) {
  app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
}

export const db = app ? getFirestore(app,"hangoo") : null;
export const rtdb = app ? getDatabase(app) : null;

